
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Sale } from './types';
import StatisticsTrendsDetails from './StatisticsTrendsDetails.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';
@Component({
  components: { StatisticsTrendsDetails, Accordion }
})
export default class StatisticsCompanyAndUserTypeSchool extends Vue {
  @Prop({ type: Object as PropType<Sale>, default: () => {} })
  sale!: Sale;
}
